import { createApiCall } from 'lib/base';

const UPDATE_WEALTH_PROGRAM = 'WEALTH/UPDATE_WEALTH_PROGRAM';

const apiCall = createApiCall(
  UPDATE_WEALTH_PROGRAM,
  ({ id, payload }: { id: string; payload: any }) => ({
    endpoint: `/api/admin/wealth/programs/${id}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
